var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgCallcenterHeadset(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M25 15.466a3.566 3.566 0 00-1.274-2.724C23.529 9.006 20.339 6 16.498 6 12.66 6 9.47 9.006 9.274 12.743A3.566 3.566 0 008 15.466c0 1.986 1.645 3.602 3.666 3.602a.46.46 0 00.465-.457v-6.29a.452.452 0 00-.136-.323.47.47 0 00-.329-.134c-.493 0-.963.098-1.393.272.482-2.946 3.108-5.222 6.23-5.222 3.117 0 5.742 2.276 6.224 5.222-.43-.174-.9-.272-1.393-.272a.46.46 0 00-.465.457v6.29a.46.46 0 00.465.457 3.7 3.7 0 001.395-.272c-.392 2.417-2.229 4.419-4.669 5.027-.28-.513-.872-.87-1.562-.87-.958 0-1.738.684-1.738 1.524S15.54 26 16.498 26c.86 0 1.571-.553 1.708-1.274 3.091-.732 5.36-3.407 5.521-6.537A3.567 3.567 0 0025 15.466zm-13.799 2.65c-1.288-.218-2.271-1.323-2.271-2.65s.983-2.432 2.271-2.65v5.3zm5.297 6.97c-.445 0-.808-.273-.808-.61 0-.336.363-.61.808-.61.445 0 .807.274.807.61 0 .337-.362.61-.807.61zm5.3-12.27c1.289.218 2.272 1.323 2.272 2.65s-.983 2.432-2.271 2.65v-5.3z"
  }));
}

export default SvgCallcenterHeadset;